import React from "react";
import { Button } from "antd";

const getStatusProps = (status) => {
  switch (status) {
    case "pending":
      return {
        text: "Pending",
        color: "var(--ion-color-orange-600)",
        background: "var(--ion-color-orange-100)",
      };
    case "approved":
      return {
        text: "Approved",
        color: "var(--ion-color-green-600)",
        background: "var(--ion-color-green-100)",
      };
    case "needRevision":
      return {
        text: "Need Revision",
        color: "var(--ion-color-primary-500)",
        background: "var(--ion-color-primary-100)",
      };
    default:
      return {
        text: "Unknown",
        color: "black",
        background: "white",
      };
  }
};

const Status = ({ status }) => {
  const { text, color, background } = getStatusProps(status);

  return (
    <Button
      type="text"
      style={{
        fontSize: "1rem",
        color: color,
        background: background,
      }}
    >
      {text}
    </Button>
  );
};

export default Status;
